import menuToggle from './menu-toggle';
import inputField from './input-field';
import textAnimation from './text-animation';
import inViewport from './in-viewport';

export default {
    init() {
        menuToggle.init();
        inputField.init();
        textAnimation.init();
        inViewport.init();
    },
};
